import { render, staticRenderFns } from "./ProductManualList.vue?vue&type=template&id=1137adc2&scoped=true&"
import script from "./ProductManualList.vue?vue&type=script&lang=js&"
export * from "./ProductManualList.vue?vue&type=script&lang=js&"
import style0 from "./ProductManualList.vue?vue&type=style&index=0&id=1137adc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1137adc2",
  null
  
)

component.options.__file = "ProductManualList.vue"
export default component.exports